<template>
  <el-dialog
    title="学校列表"
    :visible.sync="isShow"
    :before-close="handleClose"
    width="60%"
    center
  >
    <el-form ref="searcherModel" :inline="true" :model="searcherModel">
      <el-form-item label="客户名称">
        <el-input
          size="small"
          v-model="searcherModel.keyword"
          placeholder="请输入客户名称快速检索"
        ></el-input>
      </el-form-item>
      <DistrictLinkage
        ref="DistrictLinkage"
        :provinceId="searcherModel.province_id"
        :cityId="searcherModel.city_id"
        :districtId="searcherModel.district_id"
        @change="handleChange"
      ></DistrictLinkage>
      <el-form-item>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-search"
          @click="submitSearch"
          >搜索
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      size="small"
      v-loading="loading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="customerid" type="selection"></el-table-column>
      <el-table-column
        prop="customerid"
        label="学校ID"
        width="100px"
      ></el-table-column>
      <el-table-column prop="name" label="学校名称"></el-table-column>
      <el-table-column prop="xueduan_str" label="所属学段"></el-table-column>
      <el-table-column prop="districts_str" label="所在地区"></el-table-column>
    </el-table>
    <el-row v-if="linkPage">
      <pagination
        :linkPage="linkPage"
        :enableEvent="true"
        @change="watchPageChange"
      ></pagination>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="addHide">保 存</el-button>
    </span>
  </el-dialog>
</template>
<style scoped>
.el-select {
  width: 130px;
}
.el-input {
  width: 330px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
<script>
import Pagination from "~/widgets/Pagination.vue";
import elietschool from "~/services/elietschool";
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
import bus from "~/common/eventBus";
export default {
  name: "EliteSchool",
  components: {
    Pagination,
    DistrictLinkage,
  },
  props: {
    customer: {},
    customer_id: {
      type: Number | String,
      required: true,
    },
  },
  data() {
    return {
      list: [],
      loading: false,
      linkPage: null,
      isShow: false,
      searcherModel: {
        search_type: "1",
        keyword: "",
        customer_id: "",
        page: 1,
        perPage: 20,
        province_id: 0,
        city_id: 0,
        district_id: 0,
      },
      selectedIds: [],//选中客户id数组
    };
  },
  created() {
    this.searcherModel.customer_id = parseInt(this.customer_id);
    if (this.customer) {
      this.searcherModel.province_id = this.customer.province_id;
      this.searcherModel.city_id = this.customer.city_id;
      this.searcherModel.district_id = this.customer.district_id;
    }
    this.getList(this.searcherModel);
    this.isShow = this.customer_id ? true : false;
  },
  methods: {
    getList(params) {
      this.loading = true;
      elietschool.getZujuanElietSchoolList(params).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          this.list = res.data;
          this.linkPage = res._meta;
        }
      });
    },

    // 筛选查询
    submitSearch() {
      this.getList(this.searcherModel);
    },

    addHide() {
      this.loading = true;
      if (!this.selectedIds.length) {
        this.$message({
          type: "warning",
          message: "请勾选需要隐藏的客户",
        });
      }
      var params = {
        customer_id: parseInt(this.customer_id),
        hide_customer_ids: this.selectedIds,
      };
      elietschool.createZujuanHideSchool(params).then((res) => {
        if (res.code) {
          this.$message({ type: "error", message: res.msg });
          return false;
        }
        this.$message({
          type: "success",
          message: "操作成功",
        });
        bus.$emit('refresh', params);
        this.close();
        return true;
      });
      this.loading = false;
    },

    /**
     * 监听分页改变事件
     * @param pageParams
     */
    watchPageChange(pageParams) {
      // this.searcherModel.page = pageParams["page"];
      // this.searcherModel.perPage = pageParams["perPage"];
      let params = {
        search_type: this.searcherModel.search_type,
        keyword: this.searcherModel.keyword,
        customer_id: parseInt(this.customer_id),
        province_id: this.searcherModel.province_id,
        city_id: this.searcherModel.city_id,
        district_id: this.searcherModel.district_id,
        page: pageParams["page"],
        perPage: pageParams["perPage"],
      };
      this.getList(params);
    },

    init_search() {
      this.searcherModel.keyword = "";
      this.searcherModel.province_id = 0;
      this.searcherModel.city_id = 0;
      this.searcherModel.district_id = 0;
    },

    // 关闭窗口
    handleClose() {
      this.close();
    },

    // 关闭当前窗口
    close() {
      this.isShow = false;
      // 往上层组件传递更改后的状态
      this.$emit("watchQueryRepeatClose", this.isShow);
    },

    // 选中发生改变时候触发该事件
    handleSelectionChange(val) {
      this.selectedIds = [];
      val.forEach((item, index) => {
        this.selectedIds.push(item.customerid);
      });
    },

    //地区联动 Cascader 级联选择器,切换事件,表单model赋值
    handleChange(value) {
      this.searcherModel.province_id = parseInt(value[0]);
      this.searcherModel.city_id = parseInt(value[1]);
      this.searcherModel.district_id = parseInt(value[2]);
    },
  },

  mounted() {
    // bus.$on('refresh', data => {
    //   this.init_search();
    //   let params = {
    //     search_type: this.searcherModel.search_type,
    //     keyword: this.searcherModel.keyword,
    //     customer_id: parseInt(this.customer_id),
    //   };
    //   this.getList(params);
    // }),
    // bus.$on('search', data => {
    //   this.init_search();
    //   let params = {
    //     search_type: this.searcherModel.search_type,
    //     keyword: this.searcherModel.keyword,
    //     customer_id: parseInt(this.customer_id),
    //   };
    //   if(data.level == 1){
    //     this.searcherModel.province_id = data.id;
    //     params.province_id = data.id;
    //   }else if(data.level == 2){
    //     this.searcherModel.city_id = data.id;
    //     params.city_id = data.id;
    //   }else if(data.level == 3){
    //     this.searcherModel.district_id = data.id;
    //     params.district_id = data.id;
    //   }
    //   this.getList(params);
    // })
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/order/zujuan/eliteSchool.vue